import { CODInput } from "../../ui/CODinput";
import { Textarea} from "../../ui/Textarea";

const buttonStyles = {
  save: {
    padding: "8px 16px",
    borderRadius: "4px",
    border: "none",
    background: "#07b1b0",
    color: "#fff",
    cursor: "pointer",
  },
  cancel: {
    padding: "8px 16px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    background: "#fff",
    color: "#333",
    cursor: "pointer",
  },
};

const buttonContainerStyle = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "10px",
  padding: "10px",
  marginTop: "10px",
};

const AddToolTipForm = ({ formData, onChange, onSubmit, onCancel }) => {
  return (
    <form>
      <CODInput
        label="Label"
        type="text"
        name="LabelName"
        value={formData.LabelName}
        onChange={onChange}
         disabled={true} 
      />
      <CODInput
        label="Field Name"
        type="text"
        name="FieldName"
        value={formData.FieldName}
        onChange={onChange}
         disabled={true} 
      />
      <Textarea
        label="ToolTip Text"
        name="ToolTipText"
        value={formData.ToolTipText}
        onChange={onChange}
        required
      />
     
     
     

      <div style={buttonContainerStyle}>
        <button type="submit" style={buttonStyles.save} onClick={onSubmit}>
          Save
        </button>
        <button type="button" onClick={onCancel} style={buttonStyles.cancel}>
          Cancel
        </button>
      </div>
    </form>
  );
};

export default AddToolTipForm;
